import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { tableMessageContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var TableNoResults = function TableNoResults(_ref) {
  var emptyMessage = _ref.emptyMessage;
  return ___EmotionJSX("section", {
    css: tableMessageContainer
  }, ___EmotionJSX("div", {
    className: "table-message-icon"
  }, ___EmotionJSX(Icon, {
    iconName: "las la-search",
    color: "primary",
    size: 96
  })), ___EmotionJSX("h4", {
    className: "table-message-title"
  }, emptyMessage));
};
TableNoResults.propTypes = {
  emptyMessage: PropTypes.string
};